import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from 'src/components/login/login.component';
import { PasswordComponent } from 'src/components/password/password.component';
import { ResetPasswordComponent } from 'src/components/reset-password/reset-password.component';
// import { PreLoginGuardGuard } from 'src/guards/pre-login-guard.guard';
import { AuthComponent } from 'src/views/auth/auth.component';
// import { PreLoginComponent } from 'src/views/pre-login/pre-login.component';
const routes: Routes = [    
    {
        path: 'auth', component: AuthComponent, 
        // canActivate: [PreLoginGuardGuard], 
        // canActivateChild: [PreLoginGuardGuard],
        children: [
            { path: '', redirectTo: 'login', pathMatch: 'full' },            
            { path: 'login', component: LoginComponent },
            { path: 'password', component: PasswordComponent },
            { path: 'reset-password/:token', component: ResetPasswordComponent }
        ]
    }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AuthRoutingModule { }
